import { render, staticRenderFns } from "./_id.vue?vue&type=template&id=08ad38d2&scoped=true"
import script from "./_id.vue?vue&type=script&lang=js"
export * from "./_id.vue?vue&type=script&lang=js"
import style0 from "./_id.vue?vue&type=style&index=0&id=08ad38d2&prod&lang=scss"
import style1 from "./_id.vue?vue&type=style&index=1&id=08ad38d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ad38d2",
  null
  
)

export default component.exports